import React, { useState, useEffect } from "react";
import AllKeysTable from "../../Common/AllKeysTable";
import { getLocalTimeFromEpoch } from "../../../../../utils";
import { defaultFieldValue } from "../../../../Common/Table";

const Lifecycle = ({ data = {} }) => {
  function getItems() {
    return data.lifecycles || [];
  }
  const fieldValue = (row, key) => {
    switch (key) {
      case "timestamp":
        let d = getLocalTimeFromEpoch(row.timestamp);

        return d;
      default:
        return defaultFieldValue(row, key);
    }
  };
  return (
    <div>
      <h2>Trip lifecycle</h2>
      <AllKeysTable
        data={getItems()}
        fieldValue={fieldValue}
        priorityHeaders={[
          "trip_id",
          "driver_id",
          "event_name",
          "previous_state",
          "current_state",
          "timestamp",
        ]}
      />
    </div>
  );
};

export default Lifecycle;
